import { render, staticRenderFns } from "./IconButton.vue?vue&type=template&id=2ff5b9a6&scoped=true"
import script from "./IconButton.vue?vue&type=script&lang=ts"
export * from "./IconButton.vue?vue&type=script&lang=ts"
import style0 from "./IconButton.vue?vue&type=style&index=0&id=2ff5b9a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ff5b9a6",
  null
  
)

export default component.exports